import { loadStripe, Stripe } from "@stripe/stripe-js";

// only instantiate the class for testing.
export class StripeLoader {
  private stripePromise: Promise<Stripe | null> | null = null;

  async getStripe(key?: string | null): Promise<Stripe | null> {
    if (!this.stripePromise && key) {
      try {
        this.stripePromise = loadStripe(key);
      } catch (e) {
        console.error(e);
      }
    }

    return this.stripePromise;
  }
}

export const stripeLoader = new StripeLoader();
